import { render } from "./CharityPartner.vue?vue&type=template&id=6bbe3878&ts=true"
import script from "./CharityPartner.vue?vue&type=script&lang=ts"
export * from "./CharityPartner.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__